<template>
	<div>
		<section class="p-b-15 d-f justify-c f-s-16 c-606266">
			<div class="m-r-20">当月活动个数：<i class="c-warning f-w-600">{{ operationNum }}</i>个</div>
			<div class="m-r-20">当月获奖人数：<i class="c-warning f-w-600">{{ num }}</i>个</div>
			<div>当月花费奖品：<i class="c-warning f-w-600">{{ coin }}</i>翼币 <span class="m-lr-10"><i class="c-warning f-w-600">{{cardNum}}</i>张翼卡</span> <i class="c-warning f-w-600">{{ amt}}</i>元现金</div>
		</section>
		<!-- <el-row :gutter="20">
			<el-col :span="6">
				<div class="f-s-16">当月活动个数：{{ operationNum }}个</div>
			</el-col>
			<el-col :span="6">
				<div class="f-s-16">当月获奖人数：{{ num }}个</div>
			</el-col>
			<el-col :span="10">
				<div class="f-s-16">当月花费奖品：{{ coin }}翼币  {{cardNum}}张翼卡 {{ amt}}元现金</div>
			</el-col>
		</el-row> -->
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
			<el-tab-pane label="进行中的项目" name="1">
				<router-link v-if="!currentGlobalOperation" style="display: flex; justify-content: end;" v-show="appScope !== 1" :to="{path:'/event/global-detail-add', query: {status: 1}}">
					<el-button type="primary">新增活动</el-button>
				</router-link>
				<el-empty v-if="!currentGlobalOperation" description="当前无活动"></el-empty>
				<div v-else>
					<div class="d-f justify-b align-c">
						<section class="d-f f-s-14 c-606266">
							<span class="m-r-20">获奖人数：<i class="c-warning f-w-600">{{ childrenNum }}</i>个</span>
							<div>
								花费奖品：<span class="m-r-10"><i class="c-warning f-w-600">{{ childrenCoin }}</i>个翼币</span>
								<span class="m-r-10"><i class="c-warning f-w-600">{{ childrenCardNum }}</i>张翼卡</span> 
								<span class="m-r-10"><i class="c-warning f-w-600">{{ childrenAmt }}</i>元现金</span>
							</div>
						</section>
						<router-link v-show="appScope !== 1" v-if="status!== -1" :to="{path:'/event/global-detail-add', query: {status: 1}}">
							<el-button type="primary">新增活动</el-button>
						</router-link>
					</div>
					<global-event-program ref="eventProgram" :currentGlobalOperation="currentGlobalOperation"></global-event-program>
				</div>
			</el-tab-pane>
			<el-tab-pane label="待发布活动" name="6">
				<avue-crud ref="crud" 
					:option="globalOption" :search.sync="search"  
					:data="tableData" 
					@on-load="getList" 
					:page.sync="page"
					@search-change="searchChange"  
					v-model="search"
				>
					<template slot="menuRight" slot-scope="{size}">
						<router-link v-show="appScope !== 1" v-if="status!== -1" :to="{path:'/event/global-detail-add', query: {status: 1}}">
							<el-button type="primary" :size="size">新增活动</el-button>
						</router-link>
					</template>
					<template slot="startTime" slot-scope="scope">
						<span>{{ scope.row.startTime?formatDate(scope.row.startTime):'--' }}</span>
					</template>
					<template slot="endTime" slot-scope="scope">
						<span>{{ scope.row.endTime?formatDate(scope.row.endTime):'--' }}</span>
					</template>
					<template slot-scope="{row}" slot="menu">
						<el-button class="m-r-10" v-if="row.status === 6" type="primary" icon="el-icon-document" size="mini" plain @click="cancleOp(row.id)">终止</el-button>
						<router-link :to="{path:'/event/global-detail-view', query: {status: 2,id:row.id,activeName:activeName}}">
							<el-button type="success" icon="el-icon-document" size="mini" plain>查看配置</el-button>
						</router-link>
					</template>
				</avue-crud>
			</el-tab-pane>
			<el-tab-pane label="历史活动" name="3">
				<avue-crud ref="crud" 
					:option="globalOption2" :search.sync="search2" 
					:data="tableData2" @on-load="getList2" :page.sync="page2"
					@search-change="searchChange2"  v-model="search2"
				>
					<template slot="menuRight" slot-scope="{size}">
						<router-link :to="{path:'/event/global-detail-add', query: {status: 1}}">
							<el-button type="primary" :size="size">新增活动</el-button>
						</router-link>
					</template>
					<template slot="publishTime" slot-scope="scope">
						<span>{{ scope.row.publishTime?formatDate(scope.row.publishTime):'--' }}</span>
					</template>
					<template slot="endTime" slot-scope="scope">
						<span>{{ scope.row.endTime?formatDate(scope.row.endTime):'--' }}</span>
					</template>
					<template slot="cost" slot-scope="scope">
						<span>现金：{{ scope.row.actualAmt>0?scope.row.actualAmt:'--'}}元</span>
						<br>
						<span>翼币：{{ scope.row.actualCoin>0?scope.row.actualCoin:'--'}}个</span>
						<br>
						<span>翼卡：{{ scope.row.actualCardNum>0?scope.row.actualCardNum:'--'}}张</span>
					</template>
					<template slot-scope="{row}" slot="menu">
						<router-link :to="{path:'/event/global-detail-view', query: {status: 2,id:row.id,activeName:activeName}}"  style="margin-right:10px">
						<el-button type="success" icon="el-icon-document" size="mini" plain>查看配置</el-button>
						</router-link>
					</template>
				</avue-crud>
			</el-tab-pane>
		</el-tabs>

	</div>
</template>

<script>

import {
	currentMonthoperationRewardOverallTj,
	operationList,
	operatorTypeEnum,
	querygoingOperationRewardOverall,
	operationRewardOverallTjById,globalOperationList,cacelOperation
} from '@/api/events/eventData';
import {statistics} from '@/api/dot/flow'
import {mapGetters, mapState} from "vuex";
import {tableOption,globalOption,globalOption2} from "@/const/crud/events/eventData";
import {formatDate} from "@/util/date";
import globalEventProgram from "@/views/dot/order/taskTemplate/global-event-program";

export default {
	components: {globalEventProgram},
	props:['appScope','orderId'],
	data() {
		return {
			currentGlobalOperation:{},
			tempOperatorTypeEnum:[],
			childrenNum:0,
			childrenCoin:0,
			childrenCardNum:0,
			childrenAmt:0,
			operationNum:0,
			cardNum:0,
			num:0,
			amt:0,
			coin:0,
			activeName: '1',
			dialogVisible:false,
			dialogLimitTime:0,
			dialogWordCount:0,
			dialogFlowId:0,
			page: {
				currentPage: 1, // 当前页数
				pageSize: 10,
				total: 0
			},
			page2: {
				pageSize: 10,
				total: 0,
				currentPage: 1, // 当前页数
			},
			currentRow:{},
			search:{
				status:''
			},
			search2:{
				status:''
			},
			tableData: [],
			tableData2: [],
			tableOption: tableOption,
			globalOption: globalOption,
			globalOption2: globalOption2,
			status:1,
			staParams: null,
		}
	},
	created() {
		operatorTypeEnum().then(res=>{
			if (this.activeName === '6') {
				this.globalOption.column[this.globalOption.column.length - 1].dicData = res.data.data.filter(
				item => item.value === 6 || item.value === 1);
			} else if (this.activeName === '3') {
				this.globalOption2.column[this.globalOption2.column.length - 1].dicData = res.data.data.filter(
				item => item.value !== 6 && item.value !== 1 && item.value !== 2);
			} else {
			}
			this.tempOperatorTypeEnum = res.data.data;
		})
		if (this.$route.query.activeName) {
			this.activeName = this.$route.query.activeName;
		}
		// this.$set(this.globalOption.column[this.globalOption.column.length - 1], 'search', this.activeName === '6');
	},
	beforeRouteEnter(to, from, next) {
		next(vm=>{
			vm.curPath = to.path;
			vm.oldPath = from.path;
		})
	},
	mounted() {
		currentMonthoperationRewardOverallTj().then(res=>{
			let data = res.data.data;
			this.operationNum = data.operationNum;
			this.cardNum = data.cardNum;
			this.num = data.num;
			this.amt = data.amt;
			this.coin = data.coin;
		})
		querygoingOperationRewardOverall().then(res=>{
			this.currentGlobalOperation = res.data.data;
			if (res.data.data) {
				operationRewardOverallTjById({
					operationId: res.data.data.id,
					planId: null
				}).then(re => {
					let result = re.data.data;
					this.childrenNum = result.num;
					this.childrenCardNum = result.cardNum;
					this.childrenAmt = result.amt;
					this.childrenCoin = result.coin;
				})
			}
		})
		this.staParams = {
			u_id: this.userInfo.staffId,
			time: new Date().getTime(),
			browser: navigator.userAgent.toLowerCase(),
			url: document.URL,
			scene_name: '全局活动'
		}
    	this.statistics();
	},
	watch:{
		activeName(val, oldVal) {
			if (val === '1') {
				querygoingOperationRewardOverall().then(res=>{
					this.currentGlobalOperation = res.data.data;
					if (res.data.data) {
						operationRewardOverallTjById({
							operationId: res.data.data.id,
							planId: null
						}).then(re => {
							let result = re.data.data;
							this.childrenNum = result.num;
							this.childrenCardNum = result.cardNum;
							this.childrenAmt = result.amt;
							this.childrenCoin = result.coin;
						})
					}
				})
			} else if (val === '6') {
				this.globalOption.column[this.globalOption.column.length - 1].dicData = this.tempOperatorTypeEnum.filter(
					item => item.value === 6 || item.value === 1);
			} else {
				this.globalOption2.column[this.globalOption2.column.length - 1].dicData = this.tempOperatorTypeEnum.filter(
				it => it.value !== 6 && it.value !== 1 && it.value !== 2);
			}
		}
	},
	computed: {
		...mapGetters(['permissions']),
		...mapState({
			userInfo: state => state.user.userInfo
		}),
	},
	methods: {
		statistics() {
			statistics(Object.assign({
				event_type: 'view',
				ref_url: this.oldPath,
			}, this.staParams))
		},

		cancleOp(id) {
			this.$confirm('活动已经审核通过,终止以后,活动不再发布,是否确认终止活动', '提示', {
				dangerouslyUseHTMLString: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				cacelOperation({operationId:id}).then(res=>{
					let code = res.data.data;
					if (code > 0) {
						this.$message.success('终止成功');
						this.getList(this.page);
					} else if (code === -1) {
						this.$message.error('参数不能为空');
					} else if (code === -2) {
						this.$message.error('活动不存在');
					} else if (code === -3) {
						this.$message.error('状态已改变');
					} else {
						this.$message.error('未知错误，请联系管理员');
					}
				})
			}).catch(() => {
				// this.$message.error('未知错误，请联系管理员');
			});
		},

		init() {
			operationList({
				current: this.page.currentPage,
				size: this.page.pageSize,
				orderId: this.orderId
			}).then(response => {
				this.tableData = response.data.data.records
				this.page.total = response.data.data.total
			})
		},
		searchChange(form, done) {
			if (form.startTime && form.startTime.length > 0) {
				this.search.startTimeQ = form.startTime[0].getTime();
				this.search.startTimeZ = form.startTime[1].getTime();
			} else {
				delete this.search.startTimeQ
				delete this.search.startTimeZ
			}
			if (form.endTime &&　form.endTime.length > 0) {
				this.search.endTimeQ = form.endTime[0].getTime();
				this.search.endTimeZ = form.endTime[1].getTime();
			} else {
				delete this.search.endTimeQ
				delete this.search.endTimeZ
			}
			this.page.currentPage = 1
			this.getList(this.page, form)
			done()
		},
		searchChange2(form, done) {
			if (form.publishTime && form.publishTime.length > 0) {
				this.search2.publishTimeQ = form.publishTime[0].getTime();
				this.search2.publishTimeZ = form.publishTime[1].getTime();
			} else {
				delete this.search2.publishTimeQ
				delete this.search2.publishTimeZ
			}
			if (form.endTime &&　form.endTime.length > 0) {
				this.search2.endTimeQ = form.endTime[0].getTime();
				this.search2.endTimeZ = form.endTime[1].getTime();
			} else {
				delete this.search2.endTimeQ
				delete this.search2.endTimeZ
			}
			this.page2.currentPage = 1
			this.getList2(this.page2, form)
			done()
		},
		formatDate(time) {
			let date = new Date(parseFloat(time))
			return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		},
		list (page, params) {
			let target = {
				current: page.currentPage,
				size: page.pageSize,
				status: this.activeName,
				tab:1
			};
			globalOperationList(Object.assign(target, params, this.search)).then(response => {
				this.tableData = response.data.data.records
				this.page.total = response.data.data.total
			});
		},
		list2 (page, params) {
			let target = {
				current: page.currentPage,
				size: page.pageSize,
				status: this.activeName,
				tab:2
			};
			globalOperationList(Object.assign(target, params, this.search2)).then(response => {
				this.tableData2 = response.data.data.records
				this.page2.total = response.data.data.total
			});
		},
		getList(page, params) {
			this.list(page, params);
		},
		getList2(page, params) {
			this.list2(page, params);
		},
		handleClick(tab, event) {
			if (tab.name === '6') {
				this.getList({
					total: 0, // 总页数
					currentPage: 1, // 当前页数
					pageSize: 20 // 每页显示多少条
				});
			}
			if (tab.name === '3') {
				this.getList2({
					total: 0, // 总页数
					currentPage: 1, // 当前页数
					pageSize: 20 // 每页显示多少条
				});
			}

		},
	},

}
</script>
<style lang="scss" scoped>
.avue-view {
  background: #FFFFFF;
  padding: 20px;
}

:deep(.avue-group--card:last-child) {
  margin-bottom: 0px !important;
}

.el-table__body tr.hover-row.current-row > td, .el-table__body tr.hover-row.el-table__row--striped.current-row > td, .el-table__body tr.hover-row.el-table__row--striped > td, .el-table__body tr.hover-row > td {
  background-color: unset;
}

.el-table__expanded-cell[class*=cell] {
  padding: 10px 10px 10px 60px;
}
:deep(.el-table__expanded-cell){
  tr.hover-row{
    background-color: unset !important;
    td{
      background-color: unset !important;
    }
  }
}

:deep(.el-table__expanded-cell[class*=cell]){
  padding: 10px;
}
.dialog-div{
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.slef-footer{
  display: flex;
  justify-content: space-around;
}
</style>

